import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const Blog = ({
  data: {
    blog: { posts = [] },
  },
  ...props
}) => (
  <Layout {...props}>
    <SEO
      title="Blog | Powerplay"
      description="Working in infrastructure industry? Stay tuned with Powerplay's blog that regularly shares industry news and knowledge on areas such as Project Planning, Material Management, Site Reporting and many more!"
    />
    <section className="blog-main">
      <div className="container">
        <div className="featured-blog">
          <div className="featured-blog-img">
            <img
              src={`/img/blog/${posts[0]?.frontmatter?.featuredImage}`}
              alt={posts[0]?.frontmatter?.title}
            />
          </div>
          <div className="blog-featured-text">
            <h1>{posts[0]?.frontmatter?.title}</h1>
            <p>{posts[0]?.excerpt}</p>
            <Link className="button button-white" to={posts[0]?.fields?.slug}>
              Read More
            </Link>
          </div>
        </div>
      </div>
    </section>
    <section
      className="pad100 bg-lightblue blog-listing"
      style={{ paddingBottom: '1px' }}>
      <div className="container">
        <div className="flex-row">
          {posts.slice(1).map((post) => (
            <div key={post.id} className="col col-4">
              <Link to={post.fields.slug} className="blog-single">
                <img
                  src={`/img/blog/${post?.frontmatter?.featuredImage}`}
                  alt="blog"
                />
                <h2>{post.frontmatter.title}</h2>
                <p>{post.excerpt}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  </Layout>
);

Blog.propTypes = {
  data: PropTypes.shape({
    blog: PropTypes.shape({
      posts: PropTypes.arrayOf(
        PropTypes.shape({
          fields: PropTypes.shape({
            slug: PropTypes.string.isRequired,
          }).isRequired,
          frontmatter: PropTypes.shape({
            title: PropTypes.string.isRequired,
            featuredImage: PropTypes.string.isRequired,
          }).isRequired,
          excerpt: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default Blog;

export const pageQuery = graphql`
  query BlogQuery {
    blog: allMarkdownRemark {
      posts: nodes {
        frontmatter {
          date(fromNow: true)
          title
          author
          featuredImage
        }
        excerpt
        id
        fields {
          slug
        }
      }
    }
  }
`;
